import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import {
  Box,
  Checkbox,
} from '../../components';
import { updateFeatures } from '../../modules/features';
import Feature from './Features';
import api from '../../utils/services';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  features: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      carrierId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const Indent = styled.div`
  padding-left: ${props => props.theme.space_inset_md};
`;

class BestigeFeatures extends Component {
  constructor(props) {
    super(props);
    // Temporary copy of features so they can be
    this.state = {
      ...props.features,
      loading: true,
    };
  }

  componentDidMount() {
    // Fetch features just in case they have been updated
    const { match: { params: { carrierId } } } = this.props;
    api.features(carrierId)
      .then((data) => {
        const features = data.reduce((acc, f) => {
          acc[f.type] = f.enabled;
          return acc;
        }, {});
        this.setState({ ...features, loading: false });
        const { dispatch } = this.props;
        dispatch(updateFeatures(features));
      });
  }

  handleChange = (event) => {
    const { checked, name } = event.target;

    this.setState({
      [name]: checked,
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { dispatch } = this.props;
    const { match: { params: { carrierId } } } = this.props;
    const { loading, ...rest } = this.state;
    api.updateFeatures(carrierId, rest)
      .then(() => {
        dispatch(updateFeatures(rest));
      });
  };

  // See structure in comment in render function
  renderFeatures = (featureDisplayInfo, indentLevel = 0) => {
    const unsavedFeatures = this.state;
    return Object.keys(featureDisplayInfo).map((feature) => {
      const displayInfo = featureDisplayInfo[feature];
      let renderedSubfeatures;
      if (displayInfo.subFeatures) {
        renderedSubfeatures = this.renderFeatures(displayInfo.subFeatures, indentLevel + 1);
      }

      // FormField does not seem to pass the label down to the checkbox
      // so we use a Checkbox directly
      return (
        <Box key={feature} marginTop={`${0.75 / (3 * indentLevel + 1)}em`}>
          <Checkbox
            label={displayInfo.displayText}
            name={feature}
            checked={unsavedFeatures[feature]}
            onChange={this.handleChange}
          />
          <Indent>
            {renderedSubfeatures}
          </Indent>
        </Box>
      );
    });
  }

  render() {
    /* Note: A feature must be added to ./modules/features.js to be used
     *
     * Structure for display info below:
     * {
     *   FeatureName: {
     *     displayText: What to show on front end
     *     subFeatures: {
     *       ...same as top level object for any dependent features
     *     }
     *   }
     * }
     */
    const featureDisplayInfo = {
      plans: {
        displayText: 'Plans',
      },
      customContent: {
        displayText: 'Custom Content - Enables CMS to edit front end. Defaults to only plain text.',
        subFeatures: {
          richText: {
            displayText: 'Rich Text - Enable content to be rich text. Requires Custom Content.',
          },
          staticHtml: {
            displayText: 'Static HTML - Enable content to be static html snippets. Does not require Custom Content.',
          },
          liquidTemplates: {
            displayText: 'Liquid Templates - Enable content to be Liquid templates. Requires Custom Content. (Beta)',
          },
        },
      },
      theme: {
        displayText: 'Color Customization I.E. Theming',
      },
      forms: {
        displayText: 'Forms (Pre-Alpha)',
      },
      staticFiles: {
        displayText: 'Static Files - Upload static files to S3 bucket.',
      },
    };

    const featuresMarkup = this.renderFeatures(featureDisplayInfo);
    const { loading } = this.state;
    return (
      <Feature
        render={featuresMarkup}
        title="Bestige Features"
        loading={loading}
        submit={this.handleSubmit}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    features: state.features,
  };
}
BestigeFeatures.propTypes = propTypes;
// TODO do we want to add mapDispatchToProps? Will it work with middleware?
export default connect(mapStateToProps)(BestigeFeatures);
